var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GeneralTreeFolder'),_c('div',{staticClass:"flex items-center justify-end"},[_vm._t("interactive-button-section")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }